import { Loop } from './animation/loop';
import { Animation } from './animation';
import { Ease } from './ease';

const loop = new Loop({ targetFps: 60 });
const elements = document.body.querySelectorAll('.mb-kiss');

elements.forEach(element => {
  let totalCounter: Animation<{ value: number }> | null;
  let resultCounter: Animation<{ value: number }> | null;
  let selectedChecboxElement: Element | null = null;
  const errorElement = element.querySelector('.mb-kiss-error') as Element;

  // 背景色変更
  const valueContentColor = element.getAttribute('data-background') || '';
  const valueViewElement = element.querySelector('.mb-kiss-select') as HTMLElement;
  valueViewElement.style.background = valueContentColor;

  const resultViewElement = element.querySelector('.mb-kiss-display-text-after');
  if (resultViewElement) {
    const cast = resultViewElement as HTMLElement;
    cast.style.background = valueContentColor;
  }

  // ドラムロール削除
  const displaysElement = element.querySelector('.mb-kiss-displays') as HTMLElement;
  const inElement = displaysElement.querySelector('.mb-kiss-display');
  if (!inElement) {
    displaysElement.remove();
  }

  // 箱数の選択
  let boxNum = 0;
  const selectBoxElements = element.querySelectorAll('.mb-kiss-select-box');
  selectBoxElements.forEach((selectElement, index) => {
    const labelElement = selectElement.querySelector('.mb-kiss-checkbox') as HTMLElement;
    const inputElement = labelElement.querySelector('.mb-kiss-checkbox-input') as HTMLInputElement;

    inputElement.addEventListener('click', event => event.stopPropagation());
    labelElement.addEventListener('click', () => {
      boxNum = index;

      valueViewElement.classList.remove('is-active');
      const optionContents = element.querySelectorAll('.mb-kiss-contents-box');
      optionContents.forEach(content => {
        content.classList.remove('is-active');
      });

      // テキスト出力
      const text = labelElement.querySelector('.mb-kiss-checkbox-label') as HTMLElement;
      const conditionTextElements = element.querySelectorAll('.mb-kiss-color');
      conditionTextElements.forEach(textElement => {
        if (text.textContent) {
          textElement.textContent = text.textContent.trim();
        }
      });

      selectedChecboxElement = labelElement;

      errorElement.classList.remove('is-enabled');
      resultElement.classList.remove('is-enabled');
      calcElement.classList.add('is-enabled');

      if (totalCounter) {
        totalCounter.change(Number(labelElement.getAttribute('data-value') || '0'));
      }

      const distanceData = element.querySelector('.distance-data');
      const timeData = element.querySelector('.time-data');
      if (!distanceData || !timeData) {
        return;
      }

      distanceData.textContent = labelElement.getAttribute('data-distance');
      timeData.textContent = labelElement.getAttribute('data-time');
    });
  });

  // 計算ボタン
  const buttonElement = element.querySelector('.mb-kiss-footer-button') as HTMLButtonElement;
  buttonElement.addEventListener('click', () => {
    if (!selectedChecboxElement) {
      errorElement.classList.add('is-enabled');
      return;
    }

    valueViewElement.classList.add('is-active');

    calcElement.classList.remove('is-enabled');
    resultElement.classList.add('is-enabled');

    if (resultCounter) {
      resultCounter.reset();
      resultCounter.change(Number(selectedChecboxElement.getAttribute('data-result') || '0'));
    }

    const optionContents = element.querySelectorAll('.mb-kiss-contents-box');
    optionContents.forEach((content, index) => {
      if (index === boxNum) {
        content.classList.add('is-active');
      } else {
        content.classList.remove('is-active');
      }
    });
  });

  // 紙タバコの合計
  const calcElement = element.querySelector('.mb-kiss-calc') as Element;
  loop.queue(task => {
    const displayElement = calcElement.querySelector('.mb-kiss-display-content');
    if (displayElement) {
      totalCounter = new Animation(task, { fps: loop.options.targetFps, duration: 2 });
      totalCounter.update(context => {
        return {
          value: context.from + Ease.easeOutQuart(context.progress) * (context.to - context.from),
        };
      });

      totalCounter.draw(data => {
        displayElement.textContent = Math.floor(data.value).toLocaleString();
      });
    }
  });

  // 比較後
  const resultElement = element.querySelector('.mb-kiss-result') as Element;
  loop.queue(task => {
    const displayElement = resultElement.querySelector('.mb-kiss-display-content') as Element;
    resultCounter = new Animation(task, { fps: loop.options.targetFps, duration: 2 });
    resultCounter.update(context => {
      return {
        value: context.from + Ease.easeOutQuart(context.progress) * (context.to - context.from),
      };
    });

    resultCounter.draw(data => {
      displayElement.textContent = Math.floor(data.value).toLocaleString();
    });
  });
});

loop.run();
